var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { QuestionBar_ } from '../../../../areas/QuestionBar/QuestionBar_';
let DraftLayoutRight = class DraftLayoutRight extends React.PureComponent {
    render() {
        const { app } = this.props;
        return (React.createElement("div", { className: "right_of_inner", style: {
                minWidth: app.stage.draftLayout.availableWidth - app.stage.draftLayout.width > 160 ? 160 : 0,
                display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
            } },
            React.createElement(QuestionBar_, { app: app }),
            React.createElement("div", null,
                React.createElement("div", { id: "schlaukopf.de_ad_1", className: "hideBelow1000Width", style: { marginBottom: 5, marginTop: 20, marginRight: 5 } }),
                React.createElement("div", { id: "schlaukopf.de_ad_2", className: "hideBelow1000Width", style: { marginBottom: 5, marginRight: 5 } }),
                React.createElement("div", { id: "schlaukopf.de_ad_3", className: "hideBelow1000Width", style: { marginRight: 5 } }))));
    }
};
DraftLayoutRight = __decorate([
    observer
], DraftLayoutRight);
export { DraftLayoutRight };
